module.exports = __webpack_public_path__ + "img/bg_color.417e0633.png";